import PropTypes from "prop-types";
import React from "react";
import colors from "../styles/colors";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";

const Text = ({ children, className, color, size, align, breakAll, tooltip, ellipsis, date, onClick }) => {
  if (ellipsis) {
    className = className ? `${className} -ellipsis` : "-ellipsis";
  }
  if (date) {
    className = className ? `${className} -date` : "-date";
  }
  return tooltip ? (
    <StyledContainer>
      <StyledText
        className={className}
        color={color}
        size={size}
        align={align}
        breakAll={breakAll}
        data-tip={children}
        ellipsis={ellipsis}
      >
        {date ? children.replace(" - ", " -\n") : children}
      </StyledText>
      {tooltip && <Tooltip />}
    </StyledContainer>
  ) : (
    <StyledText
      className={className}
      color={color}
      size={size}
      align={align}
      breakAll={breakAll}
      onClick={onClick}
      ellipsis={ellipsis}
    >
      {date ? children.replace(" - ", " -\n") : children}
    </StyledText>
  );
};

Text.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  color: PropTypes.string,
  size: PropTypes.string,
  align: PropTypes.string,
  breakAll: PropTypes.bool,
  tooltip: PropTypes.bool,
  ellipsis: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  date: PropTypes.bool,
};

const StyledText = styled.p.attrs((props) => ({
  color: props.color || colors.mainText,
  size: props.size || "14px",
  align: props.align,
  wordBreak: props.breakAll ? "break-all" : "break-word",
  lineClamp: props.ellipsis > 1 ? props.ellipsis : 1,
}))`
  white-space: pre-wrap;
  margin: 0;
  font-size: ${(props) => props.size};
  color: ${(props) => props.color};
  text-align: ${(props) => props.align};
  font-family: "Poppins", "Kanit", "Helvetica Neue", sans-serif;
  word-break: ${(props) => props.wordBreak};

  &.-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: ${(props) => props.lineClamp};
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 2em;
  }

  &.-date {
    text-align: left;
    white-space: pre;
  }

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TextTitle = styled(Text)`
  font-weight: 700;
`;

const TextHeader = styled.h1.attrs((props) => ({
  color: props.color || colors.mainText,
  align: props.align,
}))`
  margin: 0;
  font-size: 32px;
  color: ${(props) => props.color};
  text-align: ${(props) => props.align};
  font-family: "Poppins", "Kanit", "Helvetica Neue", sans-serif;
`;
const TextDescription = styled.p.attrs((props) => ({
  color: props.color || colors.descriptionText,
  size: props.size || "12px",
  align: props.align,
}))`
  margin: 0;
  font-size: ${(props) => props.size};
  color: ${(props) => props.color};
  text-align: ${(props) => props.align};
  font-family: "Poppins", "Kanit", "Helvetica Neue", sans-serif;
`;

export { Text, TextHeader, TextTitle, TextDescription };

const StyledContainer = styled.div`
  position: relative;
`;

const Tooltip = () => <ReactTooltip effect="solid" />;
